import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {ConfigurationModel} from '../../models/configuration.model';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {TestConnectionService} from '../../services/test-connection.service';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {GenerateDateFromTimestampService} from '../../services/generate-date-from-timestamp.service';
import {FindProductPriceService} from '../../services/find-product-price.service';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';
import {AddAccessoriesPage} from '../add-accessories/add-accessories.page';
import {SysConfigModel} from '../../models/sys-config.model';
import {FindSystemConfigService} from '../../services/find-system-config.service';
import {GeneralService} from '../../services/general.service';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import { DocumentTypes } from 'src/app/definitions/document-types';

@Component({
    selector: 'app-equipment-multi-select',
    templateUrl: './equipment-multi-select.component.html',
    styleUrls: ['./equipment-multi-select.component.scss'],
})
export class EquipmentMultiSelectComponent implements OnInit {

    @Input() document: DocumentModel;
    @Input() behaviour: string;
    equipmentList: DetaillineDTOModel[] = [];
    queryText = '';
    loading: any;
    lastUpdate: string;
    configuration: ConfigurationModel;
    mobileConfiguration: MobileConfigurationModel;
    standardContractTime: string;
    standardReturnTime: string;
    overbookingAllowed: SysConfigModel;

    constructor(private modalController: ModalController,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private testConnectionService: TestConnectionService,
                private refreshdatabaseService: RefreshdatabaseService,
                private loadingController: LoadingController,
                private generateDateFromTimestamp: GenerateDateFromTimestampService,
                private docTypes: DocumentTypes,
                private findProductPriceService: FindProductPriceService,
                private findEquipmentPriceService: FindEquipmentPriceService,
                private findSysConfigService: FindSystemConfigService,
                private alertController: AlertController,
                private generalServices: GeneralService) {
    }

    ngOnInit() {
        this.configuration = this.stateManagerService.getCollection(this.collectionsNames.CONFIGURATION);
        this.mobileConfiguration = this.stateManagerService.getCollection(this.collectionsNames.MOBILECONFIGURATION);
        this.standardContractTime = this.configuration.standardContractTime ? this.configuration.standardContractTime : '08:00';
        this.standardReturnTime = this.configuration.standardReturnTime ? this.configuration.standardReturnTime : '17:00';
        this.overbookingAllowed = this.findSysConfigService.findSystemSettingByNumber(320);
        this.formatLastUpdateDate();
        this.loadEquipment();
    }

    loadEquipment() {
        console.log( "im running load equipment");
        let tempEquipmentList;
        if (this.document.documentType === this.docTypes.CONTRACT ||
            this.document.documentType === this.docTypes.LOAN ||
             this.document.documentType === this.docTypes.INVOICE || 
             this.mobileConfiguration.mobilehireHealthCareInUse === 1) {
            tempEquipmentList = this.stateManagerService.getCollection(this.collectionsNames.EQUIPMENT);
            tempEquipmentList = tempEquipmentList.filter(at => {
                return at.stat != 7;
            });
        } else {
            tempEquipmentList = this.stateManagerService.getCollection(this.collectionsNames.EQUIPMENTDISTINCTPDESC);
        }
        this.equipmentList = JSON.parse(JSON.stringify(tempEquipmentList));
    }

    async fetchEquipment(event: any) {
        try {
            await this.testConnectionService.pingServer();
            await this.refreshdatabaseService.refreshPlantHireResource();
            this.formatLastUpdateDate();
            this.loadEquipment();
            await event.target.complete();
        } catch (e) {
            await event.target.complete();
        }
    }

    async insertLinesIntoDocument(details: DetaillineDTOModel[]) {
        for (const line of details) {
            if (line.isChecked) {
                await this.dlgCheckPlantStatus(line);
            }
        }
    }

    insertLineIntoDocument(line: DetaillineDTOModel) {
        const tempLine = JSON.parse(JSON.stringify(line)) as DetaillineDTOModel;
        let discount = 0;
        tempLine.overrideDescriptionNote = tempLine.description;
        tempLine.qty = (tempLine.qty && tempLine.qty > 0) ? tempLine.qty : 1;
        tempLine.fromDate = this.formDate(this.document.scheduledDate, this.standardContractTime);
        tempLine.toDate = this.formDate(this.document.scheduledDate, this.standardReturnTime);
        this.findEquipmentPriceService.getPrice(tempLine, this.document.customer).then(res => {
            console.log(res);
            res.filter(equip => {
                console.log(equip);
                if (equip.pdesc === tempLine.pdesc) {
                    this.findEquipmentPriceService.isDiscountable(equip.tender).then(result => {
                        console.log(result);
                        if (result === 1) {
                            discount = this.document.customer.hireDisc;
                        } else {
                            discount = 0;
                        }
                    });
                    tempLine.weeklyRate = equip.week;
                    tempLine.chargeLine = this.findEquipmentPriceService.addChargeLine(equip);
                    console.log(tempLine.chargeLine);
                } else {
                    discount = 0;
                }
                tempLine.discount = discount;
            });
        });
        delete tempLine.isChecked;
        this.checkAccessories(tempLine);
        this.document.detailLines.push(tempLine);
    }

    cancelModal() {
        this.modalController.dismiss();
    }

    formatLastUpdateDate() {
        this.lastUpdate = this.generateDateFromTimestamp.formatLastUpdateDate(this.configuration.equipmentDateTime);
    }

    formDate(date: string, time: string) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        const hour = time.substr(0, 2);
        const minute = time.substr(3, 2);

        const resDate = new Date();
        resDate.setFullYear(+year, +month - 1, +day);
        resDate.setHours(+hour, +minute);
        return resDate.toISOString();
    }

    addProducts() {
        this.insertLinesIntoDocument(this.equipmentList);
        this.modalController.dismiss();
    }

    private checkAccessories(line: DetaillineDTOModel) {
        const pdescAccessories = this.stateManagerService.getCollection(this.collectionsNames.HACCESS).filter(acc => {
            // This will check if the Pdesc matches the package and
            // will add the equip only if it is not in the package already
            return acc.packagePdesc === line.pdesc && acc.packagePdesc !== acc.pdesc;
        });
        const pluAccessories = this.stateManagerService.getCollection(this.collectionsNames.SACCESS).filter(acc => {
            return acc.packagePdesc === line.pdesc;
        });

        const accessoriesTemp = [...pdescAccessories, ...pluAccessories];

        console.log(accessoriesTemp);

        if (accessoriesTemp.length > 0) {
            this.addAccessories(accessoriesTemp, line);
        }
    }

    async addAccessories(accessoriesTemp: DetaillineDTOModel[], line: DetaillineDTOModel) {
        const modal = await this.modalController.create({
            component: AddAccessoriesPage,
            cssClass: 'modal-fullscreen',
            backdropDismiss: false,
            componentProps: {
                document: this.document,
                accessories: accessoriesTemp,
                package: line.packageName,
                equipment: line
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
        });

        return await modal.present();
    }

    async dlgCheckPlantStatus(e: DetaillineDTOModel) {
        if (e.stat === 1 || e.stat === 200 || ( this.document.documentType !== 1 && this.document.documentType !== 19 ) || e.typ === 'M' || e.typ === 'P') {
            this.insertLineIntoDocument(e);
        } else if (this.overbookingAllowed.set === 1) {
            const alert = await this.alertController.create({
                header: 'Overbooking',
                message: e.description + ' is marked as on hire,\n do you wish to overbook it?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Canceled Overbooking');
                        }
                    }, {
                        text: 'Ok',
                        handler: () => {
                            this.insertLineIntoDocument(e);
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.generalServices.createToast(e.description + ' is not available');
            return false;
        }
    }
}
